import { cn } from "@/lib/utils";

type SkeletonBarProps = {
    className?: string;
    round?: boolean;
};

const SkeletonBar = ({ className, round = false }: SkeletonBarProps) => (
    <div
        className={cn(round ? "skeleton-bar-round" : "skeleton-bar", className)}
        aria-hidden
    />
);

export default SkeletonBar;
